var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMale = function SvgMale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.667V9.333c.3-.148 1.159-1.169 1.247-1.968.238-.018.607-.235.716-1.089.06-.46-.174-.719-.314-.8 0 0 .351-.669.351-1.476 0-1.617-.635-3-2-3 0 0-.474-1-2-1-2.828 0-4 1.815-4 4 0 .737.351 1.477.351 1.477-.14.08-.374.341-.314.799.109.854.478 1.07.716 1.089.088.799.948 1.82 1.247 1.968v1.334c-.667 2-6 .666-6 5.333h16c0-4.667-5.333-3.333-6-5.333"
  })));
};
export { SvgMale as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvbWFsZS4xMTJkYmRiNi5zdmciOw==";